import React, {useState} from "react";
import useStore from "../store";
import strings from "../lang/Localiz";
import SuperPrizeList from "./SuperPrizeList";
import CommonPrizeList from "./CommonPrizeList";

function HudEndGame() {
    const [closeModal, setCloseModal] = useState(true);
    const sumEndGame = useStore((state) => state.sumEndGame);
    const lastCell = useStore((state) => state.lastCell);
    const summ_prize = useStore((state) => state.summ_prize);
    const gameOver = useStore((state) => state.gameOver);
    const prize = sumEndGame ? sumEndGame : lastCell ? summ_prize : false;

    const crystal = prize ? prize.crystal : false;
    const common_key = prize ? prize.common_key : false;
    const rare_key = prize ? prize.rare_key : false;
    const epic_key = prize ? prize.epic_key : false;
    const grenade = prize ? prize.grenade : false;
    const snowball = prize ? prize.snowball : false;
    const king = prize ? prize.king : false;
    const firework = prize ? prize.firework : false;

    const repair = prize ? prize.repair : false;
    const protection = prize ? prize.protection : false;
    const damage = prize ? prize.damage : false;
    const boost = prize ? prize.boost : false;
    const lang = strings.getLanguage();
    if ((gameOver && closeModal) || (lastCell && closeModal)) {
        return (
            <div className={"hud-modal hud-end-game-modal"}>
                <div className="close-wrapper" onClick={() => setCloseModal(false)}></div>
                <div className={"hud-modal-content-gift"}>
                    <div className={"hud-modal-content-gift-wrapper"}>
                        <div className={"hud-title"}>{strings.game.end.title}</div>
                        <div className={"found-txt"}>{strings.game.end.description}</div>
                        <div className={"found-gift"}>
                            <CommonPrizeList
                                lang={lang}
                                showCommonKey={common_key > 0}
                                showRareKey={rare_key > 0}
                                showEpicKey={epic_key > 0}
                                showGrenade={grenade > 0}
                                showSnowball={snowball > 0}
                                showKing={king > 0}
                                showFirework={firework > 0}
                                showCrystals={crystal > 0}
                                showDamage={damage > 0}
                                showBoost={boost > 0}
                                showRepair={repair > 0}
                                showProtection={protection > 0}
                                common_key={common_key}
                                rare_key={rare_key}
                                epic_key={epic_key}
                                grenade={grenade}
                                snowball={snowball}
                                king={king}
                                firework={firework}
                                crystal={crystal}
                                damage={damage}
                                boost={boost}
                                repair={repair}
                                protection={protection}
                            />
                            <SuperPrizeList
                                point_one={prize.point_one > 0}
                                point_two={prize.point_two > 0}
                                point_three={prize.point_three > 0}
                                point_four={prize.point_four > 0}
                                point_five={prize.point_five > 0}
                                point_six={prize.point_six > 0}
                                point_seven={prize.point_seven > 0}
                            />
                        </div>

                        <div onClick={() => setCloseModal(false)} className={"approve-btn"}>
                            {strings.game.end.button}
                        </div>
                    </div>
                </div>
            </div>
        );
    } else return null;
}

export default HudEndGame;
